import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

/** The bar at the top of a page opened from another: a back arrow and, optionally, a title. */
export default function BackHeader({ title }: { title?: string }) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-10 border-b border-gray-100 bg-white">
      <div className="mx-auto flex items-center gap-2 px-4 py-4">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Back"
          className="rounded-full p-2 transition-colors hover:bg-gray-100"
        >
          <ArrowLeftIcon className="h-5 w-5 text-gray-600" />
        </button>
        {title && (
          <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
        )}
      </div>
    </div>
  );
}
